import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import PaymentDisclaimer from "../journey/payment/_tnc";
import {
  SJB_Disclaimer,
  C2PL_Disclaimer,
  C2PSN_Disclaimer,
  Sanchay_Disclaimer,
  SanchayPlus_Disclaimer,
  SanchayPar_Disclaimer,
  OpenMarket_Disclaimer,
  GIIP_Disclaimer,
  SaralJeevan_Disclaimer,
  C2A_Disclaimer,
  SMPP_Disclaimer,
  SANLP_Disclaimer,
  C2APAR_Disclaimer,
  SAGA_Disclaimer,
  LeadCapture_Disclaimer,
  OpenMarket_DisclaimerRTL,
  OpenMarket_Disclaimer_C2PSN
} from "./_disclaimer";

export default function AppFooter({ ...props }) {
  const _storeData = useSelector((state) => state);
  const { pasaStore } = _storeData;
  const { product, source, openMarket } = pasaStore;
  var isOpenMarket = false;
  var isLeadCapture = false;
  var isOpenMarketRTL = false
  var isOpenMarketC2PSN = false;
  if(pasaStore?.openMarket?.source === 'RTL_HBANK'){
    isOpenMarket = false;
    isOpenMarketRTL = true
  } else
  if (!product && !source) {
    isOpenMarket = true;
    isOpenMarketRTL = false
  }
  if(openMarket?.source?.toUpperCase() === "LEAD_CAPTURE"){
    isOpenMarket = false;
    isLeadCapture = true;
  }
  if([
    "NONHBANKC2PSNSPECIALPASA",
    "SELFSOURCENONHBANK",
    "DIRECTCHANNEL",
    "DIRECT_AG",
    "HDFC_SEC",
    "NH_DIRECT"
  ].includes(openMarket?.source?.toUpperCase())){
    isOpenMarket = false;
    isOpenMarketC2PSN = true;
  }

  const history = useHistory();
  return (
    <div className="app-footer">
      <div className="tnc-cntnr">
        <div className="title">Terms &amp; Conditions</div>
        <div className="content">
          {isOpenMarket ? (
            <OpenMarket_Disclaimer />
          ) : isOpenMarketRTL ? (
            <OpenMarket_DisclaimerRTL />
          ) : (
            <>
              {product && product?.toLowerCase() === "c2a" && (
                <C2A_Disclaimer />
              )}
              {product && product.toLowerCase() === "sjb" && <SJB_Disclaimer />}
              {product && product.toLowerCase() === "c2pl" && (
                <C2PL_Disclaimer />
              )}
              {product && product.toLowerCase() === "c2psn" && (
                <C2PSN_Disclaimer />
              )}
              {product && product.toLowerCase() === "sanchay" && (
                <Sanchay_Disclaimer />
              )}
              {product && product.toLowerCase() === "sanchaypar" && (
                <SanchayPar_Disclaimer />
              )}
              {product && product.toLowerCase() === "sanchayplus" && (
                <SanchayPlus_Disclaimer />
              )}
               {product && product.toLowerCase() === "c2apar" && (
                <C2APAR_Disclaimer />
              )}
              {product && product.toLowerCase() === "giip" && (
                <GIIP_Disclaimer />
              )}
              {product && product.toLowerCase() === "saraljeevan" && (
                <SaralJeevan_Disclaimer />
              )}
               {product && product.toLowerCase() === "smpp" && (
                <SMPP_Disclaimer />
              )}
              {product && product.toLowerCase() === "saga" && (
                <SAGA_Disclaimer />
              )}
               {product && product.toLowerCase() === "sanlp" && (
                <SANLP_Disclaimer />
              )}
              {isLeadCapture && openMarket?.source?.toUpperCase() === "LEAD_CAPTURE" && (
                <LeadCapture_Disclaimer />
              )}
               {isOpenMarketC2PSN && 
               ([
                "NONHBANKC2PSNSPECIALPASA",
                "SELFSOURCENONHBANK",
                "DIRECTCHANNEL",
                "DIRECT_AG",
                "HDFC_SEC",
                "NH_DIRECT"
                ].includes(openMarket?.source?.toUpperCase())) && (
                <OpenMarket_Disclaimer_C2PSN />
              )}
            </>
          )}
        </div>
        {/* <PaymentDisclaimer></PaymentDisclaimer> */}
      </div>
    </div>
  );
}
